"use client";

import { Components } from "@/app/(components)/_components/Components";
import ActionMenu from "@/app/(components)/generics/ActionMenu/ActionMenu";
import IconDownload from "@/app/(components)/generics/Icons/IconDownload";
import { ModalStore } from "@/app/stores/ModalStore";
import { ProjectStore } from "@/app/stores/ProjectStore";
import { TKeyCallAnalysis as TKey } from "@/app/translations/keys/TKeyCallAnalysis";
import { useT } from "@/app/translations/useT";
import { CallScopeFilter } from "@/app/types/call/CallScopeFilter";
import { DefaultProps } from "@/app/types/common/DefaultProps";

type Props = DefaultProps & {
  filter?: CallScopeFilter;
};

export default function CallAnalysisMenu(props: Props) {
  const T = useT();
  const { params, filter = {} } = props;
  const currentProject = ProjectStore((state) => state.currentProject);

  const handleExportInsights = () => {
    if (!currentProject) return;

    ModalStore.getState().openModal(
      Components.ExportInsight,
      T(TKey.CALL_EXPORT_INSIGHTS_TITLE) as string,
      { params, projectId: currentProject.id, filter },
    );
  };

  return (
    <ActionMenu
      items={[
        {
          icon: <IconDownload size={15} />,
          label: T(TKey.CALL_EXPORT_INSIGHTS_TITLE) as string,
          onClick: handleExportInsights,
        },
      ]}
    />
  );
}
